import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IOfferListOffer} from "../../offer/types/IOfferListOffer";
import {IOfferCardAddressContext} from "../../offer/utils/get_offer_card_address";
import {getAmplitudeOfferListItem} from "./get_amplitude_offer_list_item";
import {AmplitudeItemListName} from "./get_amplitude_view_item_event_properties";

export interface ITrackAmplitudeOfferViewItemListParams {
    addressContext: IOfferCardAddressContext;
    isUspVariant: boolean;
    offers: IOfferListOffer[];
    itemListId?: string;
    itemListName: AmplitudeItemListName;
}

export const trackAmplitudeOfferViewItemList = (params: ITrackAmplitudeOfferViewItemListParams) => {
    const {offers, itemListId, itemListName, isUspVariant, addressContext} = params;

    trackAmplitudeEvent("view_item_list", {
        ...(itemListId ? {item_list_id: itemListId} : {}),
        item_list_name: itemListName,
        location: "listing_page",
        products: offers.map((offer, index) => getAmplitudeOfferListItem({offer, index, isUspVariant, addressContext}))
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IOfferListOffer} from "../../offer/types/IOfferListOffer";
import {IOfferCardAddressContext} from "../../offer/utils/get_offer_card_address";
import {getAmplitudeOfferListItem} from "./get_amplitude_offer_list_item";
import {AmplitudeItemListName} from "./get_amplitude_view_item_event_properties";

export interface ITrackAmplitudeOfferViewItemListParams {
    addressContext: IOfferCardAddressContext;
    isUspVariant: boolean;
    offers: IOfferListOffer[];
    itemListId?: string;
    itemListName: AmplitudeItemListName;
}

export const trackAmplitudeOfferViewItemList = (params: ITrackAmplitudeOfferViewItemListParams) => {
    const {offers, itemListId, itemListName, isUspVariant, addressContext} = params;

    trackAmplitudeEvent("view_item_list", {
        ...(itemListId ? {item_list_id: itemListId} : {}),
        item_list_name: itemListName,
        location: "listing_page",
        products: offers.map((offer, index) => getAmplitudeOfferListItem({offer, index, isUspVariant, addressContext}))
    });
};
